import fetcher from '@api/fetchers/simpleFetcher';
import { getHost } from '@utils/api-helper/host';

const host = getHost();

export const fetchCourseData = (courseUID, authorization) =>
  fetcher(`${host}v1/collection/${courseUID}/`, { authorization });

export const fetchLessonData = (lessonUID, authorization) =>
  fetcher(`${host}v1/post/${lessonUID}/`, { authorization }).catch(() => {});

export const fetchFreeLessonListFromLessonUID = (lessonUID, authorization) =>
  fetcher(`${host}v2/post/${lessonUID}/related_items/`, {
    authorization
  }).catch(() => {});

export const fetchFreeRelatedCourses = ({
  lessonUID,
  authorUID,
  goalUID,
  topicUID
}) =>
  fetcher(
    `${host}v2/post/${lessonUID}/related_special_items?author_uid=${authorUID}&goal_uid=${goalUID}&topic_uid=${topicUID}`
  );
